// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2-HX7","errors":"Errors_errors__3ia2S"};